/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */




/* tiktok slider */

var swiper = new Swiper(".smshrs_tiktok_videos", {
    slidesPerView: 6,
    spaceBetween: 25,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 25,
        autoplay: false
      },
      481: {
        slidesPerView: 2,
        spaceBetween: 25,
        autoplay: false
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 25,
        autoplay: false
      },
      1199: {
        slidesPerView: 4,
        spaceBetween: 25,
        autoplay: false
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 25,
        autoplay: false
      }
    }
  });


 // $(".header-sub-menu-wrap.custom_megamenu .main-navi-wrapp li").hover(function () {
 //    var dataId = $(this).data("id");
 //    console.log(dataId);
 //    $(".header-sub-menu-wrap.custom_megamenu .main-navi-wrapp li").removeClass("active");
 //    $(this).addClass("active");
 //    $(".header-sub-menu-wrap.custom_megamenu .mega-menu__list").removeClass("active");
 //    $('.header-sub-menu-wrap.custom_megamenu .mega-menu__list[data-id="' + dataId + '"]').addClass("active");
 //  });




document.querySelectorAll(".header-sub-menu-wrap.custom_megamenu .main-navi-wrapp li").forEach(function (item) {
  item.addEventListener("mouseenter", function () {
    var dataId = item.getAttribute("data-id");
    console.log(dataId);

    // Remove "active" class from all li items
    document.querySelectorAll(".header-sub-menu-wrap.custom_megamenu .main-navi-wrapp li").forEach(function (li) {
      li.classList.remove("active");
    });

    // Add "active" class to the hovered li
    item.classList.add("active");

    // Remove "active" class from all mega-menu__list items
    document.querySelectorAll(".header-sub-menu-wrap.custom_megamenu .mega-menu__list").forEach(function (menu) {
      menu.classList.remove("active");
    });

    // Add "active" class to the corresponding mega-menu__list
    var targetMenu = document.querySelector('.header-sub-menu-wrap.custom_megamenu .mega-menu__list[data-id="' + dataId + '"]');
    if (targetMenu) {
      targetMenu.classList.add("active");
    }
  });
});

// var swiper = new Swiper(".smshrs_info_videos", {
//     slidesPerView: 3,
//     spaceBetween: 25,
//     loop: true,
//     // navigation: {
//     //   nextEl: '.swiper-button-next',
//     //   prevEl: '.swiper-button-prev',
//     // },
    
//     breakpoints: {
//       0: {
//         slidesPerView: 1,
//         spaceBetween: 0,
//         autoplay: {
//         delay: 2500,
//         disableOnInteraction: false,
//         },
//       },
//       481: {
//         slidesPerView: 1,
//         spaceBetween: 0,
//         autoplay: {
//         delay: 2500,
//         disableOnInteraction: false,
//         },
//       },
//       768: {
//         slidesPerView: 1,
//         spaceBetween: 0,
//         autoplay: {
//         delay: 2500,
//         disableOnInteraction: false,
//         },
//       },
//       1199: {
//         slidesPerView: 3,
//       }
//     }
//   });

/*
document.addEventListener('DOMContentLoaded', function () {
    // Get all radio buttons with class 'veredelung_options'
    var radioButtons = document.querySelectorAll('.veredelung_options input[type="radio"]');
    var playerNameField = document.getElementById('PlayerNameField');
    var playerNameInput = document.getElementById('player_name');

    // Define the values that require the player name input to be shown
    var showInputValues = ['spielername-gross', 'initialen', 'spielername-klein', 'kleiner-spielername'];

    function togglePlayerNameField() {
        // Find the checked radio button
        var selected = document.querySelector('.veredelung_options input[type="radio"]:checked');
      consloe.log(selected.getAttribute('data-value'));

        if (selected && showInputValues.includes(selected.getAttribute('data-value'))) {
            // Show the input field and make it required
            playerNameField.classList.remove('hidden');
            playerNameInput.required = true;
        } else {
            // Hide the input field and make it not required
            playerNameField.classList.add('hidden');
            playerNameInput.required = false;
            playerNameInput.value = ''; // Optionally clear input
        }
    }

    // Initial check on page load
    togglePlayerNameField();

    // Add event listeners to radio buttons
    radioButtons.forEach(function (radio) {
        radio.addEventListener('change', togglePlayerNameField);
    });
});

*/


document.addEventListener('DOMContentLoaded', function() {
    // Target all the radio buttons within 'veredelung_options'
    var radioButtons = document.querySelectorAll('.veredelung_options input[type="radio"]');  
    var playerNameField = document.getElementById('PlayerNameField');
    var playerNameInput = document.getElementById('player_name');
    // Values that require the player name input
    var showInputValues = ['ruckennummer','spielername-gross', 'initialen', 'spielername-klein', 'kleiner-spielername'];

    function togglePlayerNameField() {
        // Find the checked radio button
        var selected = document.querySelector('.veredelung_options input[type="radio"]:checked');
        var selectedValue = selected ? selected.getAttribute('data-value') : '';
        if (showInputValues.includes(selectedValue)) {
            playerNameField.classList.remove('hidden');
            playerNameInput.required = true;
        } else {
            playerNameField.classList.add('hidden');
            playerNameInput.required = false;
            playerNameInput.value = ''; // Optionally clear input
        }
    }
    // Run on page load
    togglePlayerNameField();

    // Run on click (change) of radio buttons
   /* radioButtons.forEach(function(radio) {
        radio.addEventListener('click', togglePlayerNameField);
    });
*/
});

document.body.addEventListener('click', function(event) {
  
    if (event.target.matches('.lab_kein-spielername')) {
        document.getElementById('PlayerNameField').style.display = 'none';
      document.getElementById('player_name').required = false;
      document.getElementById('player_name').value = ''; 
    }
     if (event.target.matches('.lab_kein-kleiner-spielername')) {
        document.getElementById('PlayerNameField').style.display = 'none';
      document.getElementById('player_name').required = false;
      document.getElementById('player_name').value = ''; 
    }
  if (event.target.matches('.lab_keine-initialen')) {
        document.getElementById('PlayerNameField').style.display = 'none';
      document.getElementById('player_name').required = false;
      document.getElementById('player_name').value = ''; 
    }
   if (event.target.matches('.lab_keine-ruckennummer')) {
        document.getElementById('PlayerNameField').style.display = 'none';
      document.getElementById('player_name').required = false;
      document.getElementById('player_name').value = ''; 
    }
  


  

  
    if (event.target.matches('.lab_spielername-gross')) {
        document.getElementById('PlayerNameField').style.display = 'block';
       document.getElementById('player_name').required = true;
   }
   if (event.target.matches('.lab_ruckennummer')) {
        document.getElementById('PlayerNameField').style.display = 'block';
       document.getElementById('player_name').required = true;
   }
  if (event.target.matches('.lab_spielername-klein')) {
        document.getElementById('PlayerNameField').style.display = 'block';
     document.getElementById('player_name').required = true;
    }
  
   if (event.target.matches('.lab_kleiner-spielername')) {
        document.getElementById('PlayerNameField').style.display = 'block';
      document.getElementById('player_name').required = true;
    }
  if (event.target.matches('.lab_initialen')) {
        document.getElementById('PlayerNameField').style.display = 'block';
      document.getElementById('player_name').required = true;
    }
  /*
   if (event.target.matches('.lab_spielername-klein')) {
        document.getElementById('PlayerNameField').style.display = 'block';
     document.getElementById('player_name').required = true;
    }*/   
  
});

var mySwiper = new Swiper(".swiper_customtestomonials", {
  spaceBetween: 30,
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,
  // loopAdditionalSlides: 10,
  roundLengths: true,
  // autoplay: {
  //   delay: 2000,
    
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    350: {
      slidesPerView: 1,
    },
    1024: {
      slidesPerView: 3,
    },
  }
});
